export const CREATE_CASE_CALLBACKS_FLOW_TYPE = {
  CALLBACK_FULFILLMENT: 'callback_fulfillment',
  CALLBACK_OUTBOUND: 'callback_outbound',
  FULFILLMENT: 'fulfillment',
  COMPLAINT: 'complaint',
  OUTBOUND: 'outbound',
  SOS: 'sos',
} as const

export type CreateCaseCallbacksFlowType =
  (typeof CREATE_CASE_CALLBACKS_FLOW_TYPE)[keyof typeof CREATE_CASE_CALLBACKS_FLOW_TYPE]
